import React, { useEffect, useRef, useState } from 'react';
import { Reveal } from './Reveal';
import styles from './Hero.module.css';

interface HeroProps {
  onPrimaryCtaClick: () => void;
}

export function Hero({ onPrimaryCtaClick }: HeroProps) {
  const imageRef = useRef<HTMLImageElement>(null);
  const [offsetY, setOffsetY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (imageRef.current) {
        setOffsetY(window.scrollY * 0.35);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section id="hero" className={styles.hero} aria-labelledby="hero-title">
      <div className={styles.container}>
        <Reveal className={styles.textBlock}>
          <p className={styles.eyebrow}>A daily ritual · New York</p>
          <h1 id="hero-title" className={styles.title}>
            Grow your calm.
            <br />
            <span className={styles.titleAccent}>And your own food.</span>
          </h1>
          <p className={styles.subtitle}>
            Five minutes a day. Something alive on your windowsill.
            A quiet moment that's entirely yours — in the middle of everything.
          </p>

          <div className={styles.priceRow}>
            <span className={styles.price}>$49</span>
            <span className={styles.priceSub}>· Free NYC delivery · 200 kits · First batch</span>
          </div>

          <div className={styles.actions}>
            <button type="button" className={styles.primaryButton} onClick={onPrimaryCtaClick}>
              Start My Ritual — $49
            </button>
            <a href="#ako-to-funguje" className={styles.secondaryButton}>
              See How It Works
            </a>
          </div>

          <div className={styles.trustRow}>
            <span className={styles.trustItem}>✓ First harvest in 7 days</span>
            <span className={styles.trustItem}>✓ No experience needed</span>
            <span className={styles.trustItem}>✓ Zero pesticides</span>
          </div>
        </Reveal>

        <Reveal className={styles.visualWrap} delayMs={140}>
          <div className={styles.imageWrap}>
            <div className={styles.badgeWrap}>
              <div className={styles.badge}>
                <span className={styles.badgePrice}>$49</span>
                <span className={styles.badgeLabel}>per kit</span>
              </div>
            </div>
            <img
              ref={imageRef}
              src="/hero.png"
              alt="Green Rituals — your daily growing ritual at home"
              className={styles.heroImage}
              style={{ transform: `translateY(${offsetY}px)` }}
            />
            <div className={styles.imageOverlay} aria-hidden="true" />
          </div>
          <p className={styles.imageCaption}>Day 7. Your harvest.</p>
        </Reveal>
      </div>
    </section>
  );
}
